<mat-progress-bar mode="indeterminate" *ngIf="loading"></mat-progress-bar>

<section class="workspace-page workspace-page--full workspace-page__panel--card br-compact-page" *ngIf="detail">
  <header class="workspace-page__heading">
    <h1 class="workspace-page__title">{{ detail.title }}</h1>
    <div class="workspace-page__title-actions">
      <mat-chip [ngClass]="detail.status === 'Open' ? 'chip-pending' : 'chip-inactive'"
                disableRipple>
        {{ detail.status }}
      </mat-chip>
      <button type="button" class="br-btn br-btn--outline-secondary br-btn--sm"
              (click)="back()">
        <br-icon>arrow_back</br-icon> Back to Cases
      </button>
    </div>
  </header>

  <div class="workspace-page__body br-p-3">
  <!-- Case Info card -->
  <section class="br-card case-card br-mb-3">
    <header class="br-card-header case-card__header">
      <h2 class="br-card-title">Case Info</h2>
      <ng-container *ngIf="auth.hasPermission('Case.Manage')">
        <ng-container *ngIf="!editing">
          <button type="button" class="br-btn br-btn--ghost br-icon-btn"
                  (click)="startEdit()" matTooltip="Edit case" aria-label="Edit case">
            <br-icon>edit</br-icon>
          </button>
        </ng-container>
        <ng-container *ngIf="editing">
          <button type="button" class="br-btn br-btn--ghost br-icon-btn"
                  (click)="submitEdit()" [disabled]="saving || editForm.invalid"
                  matTooltip="Save" aria-label="Save case">
            <br-icon>save</br-icon>
          </button>
          <button type="button" class="br-btn br-btn--ghost br-icon-btn"
                  (click)="cancelEdit()" matTooltip="Cancel" aria-label="Cancel editing">
            <br-icon>close</br-icon>
          </button>
        </ng-container>
      </ng-container>
    </header>

    <div class="br-card-body">
      <!-- View mode -->
      <ng-container *ngIf="!editing">
        <dl class="detail-grid">
          <dt>Customer</dt>
          <dd><a [routerLink]="['/customers', detail.customerId]">{{ detail.customerName }}</a></dd>
          <dt>Title</dt>
          <dd>{{ detail.title }}</dd>
          <dt>Description</dt>
          <dd>{{ detail.description || '—' }}</dd>
          <dt>Status</dt>
          <dd>{{ detail.status }}</dd>
          <dt>Assigned To</dt>
          <dd>{{ detail.assignedToUserName || '—' }}</dd>
          <dt>Related Ref</dt>
          <dd>{{ detail.relatedRef || '—' }}</dd>
          <dt>Created</dt>
          <dd>{{ detail.createdAt | date:'medium' }}</dd>
        </dl>
      </ng-container>

      <!-- Edit mode -->
      <ng-container *ngIf="editing">
        <form [formGroup]="editForm" class="case-form">
          <mat-form-field appearance="outline">
            <mat-label>Title</mat-label>
            <input matInput formControlName="title" maxlength="255">
            <mat-error *ngIf="editForm.get('title')?.hasError('required')">Required</mat-error>
          </mat-form-field>

          <mat-form-field appearance="outline">
            <mat-label>Description</mat-label>
            <textarea matInput formControlName="description" rows="3" maxlength="2000"></textarea>
          </mat-form-field>

          <mat-form-field appearance="outline">
            <mat-label>Related Ref</mat-label>
            <input matInput formControlName="relatedRef" maxlength="128">
          </mat-form-field>

          <mat-form-field appearance="outline">
            <mat-label>Assigned To</mat-label>
            <mat-select formControlName="assignedToUserId">
              <mat-option [value]="null">Unassigned</mat-option>
              <mat-option *ngFor="let u of users" [value]="u.id">
                {{ u.firstName }} {{ u.lastName }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </form>
      </ng-container>
    </div>
  </section>

  <!-- Resolution card — Open case -->
  <section class="br-card case-card br-mb-3" *ngIf="detail.status === 'Open' && auth.hasPermission('Case.Manage')">
    <header class="br-card-header">
      <h2 class="br-card-title">Resolution</h2>
    </header>
    <div class="br-card-body">
      <mat-form-field appearance="outline" class="case-form-field">
        <mat-label>Resolution Note</mat-label>
        <textarea matInput [(ngModel)]="resolutionNote" rows="4" maxlength="2000"
                  placeholder="Describe the resolution..."></textarea>
      </mat-form-field>
      <div class="case-actions">
        <button type="button" class="br-btn br-btn--danger br-btn--sm"
                [disabled]="!resolutionNote.trim() || saving"
                (click)="closeCase()">
          Close Case
        </button>
      </div>
    </div>
  </section>

  <!-- Resolution card — Closed case -->
  <section class="br-card case-card br-mb-3" *ngIf="detail.status === 'Closed'">
    <header class="br-card-header">
      <h2 class="br-card-title">Resolution</h2>
    </header>
    <div class="br-card-body">
      <dl class="detail-grid">
        <dt>Resolved By</dt>
        <dd>{{ detail.closedByUserName || '—' }}</dd>
        <dt>Closed At</dt>
        <dd>{{ detail.closedAt | date:'medium' }}</dd>
        <dt>Resolution Note</dt>
        <dd>{{ detail.resolutionNote || '—' }}</dd>
      </dl>
      <div class="case-actions case-actions--spaced" *ngIf="auth.hasPermission('Case.Manage')">
        <button type="button" class="br-btn br-btn--outline-primary br-btn--sm"
                [disabled]="saving" (click)="reopenCase()">
          Reopen Case
        </button>
      </div>
    </div>
  </section>

  <!-- Worklog: activity timeline scoped to this case -->
  <section class="br-card case-card" *ngIf="detail">
    <header class="br-card-header">
      <h2 class="br-card-title">Worklog</h2>
    </header>
    <div class="br-card-body">
      <app-activity-timeline [customerId]="detail.customerId" [caseId]="detail.id"></app-activity-timeline>
    </div>
  </section>
  </div>
</section>
